export default __webpack_public_path__ + "static/media/ic_palau.099aa01b.svg";